export const parseNumber = (number: string) => {
  return number.split(' ').join(' ').split(' ').join('');
};
